import React from "react";
import Navigation from "./Navigation";

export default function Header() {
  return (
    <header>
      <Navigation />
    </header>
  );
}
